import { createSelector } from 'reselect';

const getQuery = (store) => store.Session.query;

const getCurrentPaging = createSelector(getQuery, (query) => {
	const { page, perPage } = query;
	return {
		page: +page || 1,
		perPage: +perPage || 20,
	};
});

export default getCurrentPaging;
